'use client';

import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

import { useStoreCard } from './store-card-context';

export type AddressProps = ComponentProps<'p'>;

export function Address({ className, ...props }: AddressProps) {
  const { store } = useStoreCard();

  return (
    <p
      className={twMerge(
        'w-full overflow-hidden overflow-ellipsis !whitespace-nowrap',
        className,
      )}
      {...props}
    >
      {store.address.zipcode} {store.address.city}
    </p>
  );
}
